/*
 * @Description: 接口API
 * @LastEditors: Ji Yinghao
 * @Date: 2019-05-06 14:07:48
 * @LastEditTime: 2019-11-05 10:06:01
 */
import Location from './location.js'
// 开发地址 （"http://10.0.0.200:8081/"）
// 生产地址 （"http://47.107.98.190:10422/"）
// let location_ = "http://10.0.0.200:8080/";

let location_ = Location.url.dev
export default {
    URL: {
        /**
         * @description: 获取手机号验证码
         * @param {type}  : phone
         * @return: 
         * @method: "post"
         */
        "user_phone_code": location_ + "api/v1/user/phone_code",

        /**
         * @description: 医生登录
         * @param {type}  : {phone code}
         * @return: 
         * @method: "post"
         */
        "doctor_login": location_ + "api/v1/doctor/login",

        /**
         * @description: 医生信息提交审核
         * @param {type}  : {phone code}
         * @return: 
         * @method: "post"
         */
        "doctor_authentication": location_ + "api/v1/doctor/authentication",

        /**
         * @description: 医生执业点列表
         * @param {type}  : {}
         * @return: 
         * @method: "put"
         */
        "doctor_hosp_list": location_ + "api/v1/doctor/hosp_list",

        /**
         * @description: 医生获取个人信息
         * @param {type}  : {}
         * @return: 
         * @method: "get"
         */
        "doctor_info": location_ + "api/v1/doctor/info",

        /**
         * @description: 医生和用户咨询用户列表
         * @param {type}  : {}
         * @return: 
         * @method: "get"
         */
        "user_chat_trails": location_ + "api/v1/user/chat_trails",

        /**
         * @description: 医生上传头像   
         * @param {type}  : {}
         * @return: 
         * @method: "post"
         */
        "doctor_avatar": location_ + "api/v1/doctor/avatar",

        /**
         * @description: 医生收入详情
         * @param {type}  : {}
         * @return: 
         * @method: "get"
         */
        "order_income_amount": location_ + "api/v1/order/income_amount",

        /**
         * @description: 医生提现提交
         * @param {type}  : { fee file }
         * @return: 
         * @method: "post"
         */
        "order_transfer": location_ + "api/v1/order/transfer",

        /**
         * @description: 医生提现记录列表
         * @param {type}  : { fee file }
         * @return: 
         * @method: "get"
         */
        "order_transfer_list": location_ + "api/v1/order/transfer",

        /**
         * @description: 医生发送文字
         * @param {type}  : { fee file }
         * @return: 
         * @method: "get"
         */
        "message_text": location_ + "api/v1/message/text",

        /**
         * @description: 咨询记录
         * @param {type}  : { to_id }
         * @return: 
         * @method: "get"
         */
        "message_record": location_ + "api/v1/message/record",

        /**
         * @description: 医生发送图片
         * @param {type}  : { images:[],to_user_id:int }
         * @return: 
         * @method: "post"
         */
        "message_image": location_ + "api/v1/message/image",

        /**
         * @description: 医生自定义资费
         * @param {type}  : { images:[],to_user_id:int }
         * @return: 
         * @method: "post"
         */
        "doctor_product": location_ + "api/v1/doctor/product",

        /**
         * @description: 医生获取资费信息
         * @param {type}  : { images:[],to_user_id:int }
         * @return: 
         * @method: "post"
         */
        "doctor_product_info": location_ + "api/v1/doctor/product_info",

        /**
         * @description: 医生反馈信息
         * @param {type}  : { type content contact }
         * @return: 
         * @method: "post"
         */
        "user_feedback": location_ + "api/v1/user/feedback",

        /**
         * @description: 医生退出登录
         * @param {type}  : { type content contact }
         * @return: 
         * @method: "post"
         */
        "user_logout": location_ + "api/v1/user/logout",

        /**
         * @description: 医生添加备注名
         * @param {type}  : { type content contact }
         * @return: 
         * @method: "post"
         */
        "user_label": location_ + "api/v1/user/label",

        /**
         * @description: 患者IIEF-5
         * @param {type}  : { user_id }
         * @return: 
         * @method: "get"
         */
        "inspection_iief5": location_ + "api/v1/inspection/iief5",

        /**
         * @description: 患者ehs
         * @param {type}  : { user_id }
         * @return: 
         * @method: "get"
         */
        "inspection_ehs": location_ + "api/v1/inspection/ehs",

        /**
         * @description: 患者档案
         * @param {type}  : { user_id }
         * @return: 
         * @method: "get"
         */
        "inspection_cases_file": location_ + "api/v1/inspection/cases_file",

        /**
         * @description: 患者ED
         * @param {type}  : { user_id }
         * @return: 
         * @method: "get"
         */
        "inspection_ed_record": location_ + "api/v1/inspection/ed_record",

        /**
         * @description: 获取ED详情
         * @param {type}  : { id }
         * @return: 
         * @method: "get"
         */
        "inspection_ed_record_list": location_ + "api/v1/inspection/ed_record_list",


    }
}